function toDate(value) {
  if (!value) return null;
  if (typeof value?.toDate === 'function') return value.toDate();
  if (value instanceof Date) return value;
  if (Number.isFinite(Number(value?.seconds))) return new Date(Number(value.seconds) * 1000);
  const parsed = new Date(value);
  return Number.isFinite(parsed.getTime()) ? parsed : null;
}

export function cadenceFrequencyLabel(cadence, { capitalized = false } = {}) {
  const unit = cadence?.unit === 'month' ? 'month' : cadence?.unit === 'year' ? 'year' : '';
  if (!unit) return '';
  const count = Math.max(1, Number(cadence?.count ?? cadence?.intervalCount) || 1);
  const label = count === 1
    ? (unit === 'month' ? 'monthly' : 'yearly')
    : `every ${count} ${unit}s`;
  return capitalized ? `${label.charAt(0).toUpperCase()}${label.slice(1)}` : label;
}

export function formatCadenceEffectiveDate(value) {
  const date = toDate(value);
  if (!date) return '';
  return new Intl.DateTimeFormat('en-GB', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }).format(date);
}

export function getMembershipCadenceTransition(value = {}) {
  const currentCadence = value?.currentCadence || value?.currentConfig?.cadence || value?.currentConfigSnapshot?.cadence || null;
  const targetCadence = value?.targetCadence || value?.targetConfig?.cadence || value?.stripeSchedule?.targetCadence || null;
  const currentLabel = cadenceFrequencyLabel(currentCadence, { capitalized: true });
  const targetLabel = cadenceFrequencyLabel(targetCadence, { capitalized: true });
  const effectiveDate = formatCadenceEffectiveDate(value?.effectiveAt || value?.stripeSchedule?.effectiveAt);
  const changed = Boolean(currentLabel && targetLabel && currentLabel !== targetLabel);
  return {
    currentCadence,
    targetCadence,
    currentLabel,
    targetLabel,
    effectiveDate,
    changed,
    confirmedWithStripe: value?.confirmationSource === 'stripe' || value?.confirmationSource === 'current_price' || value?.stripeSchedule?.status === 'confirmed',
    confirmedByClub: value?.confirmationSource === 'club',
    manualReview: value?.status === 'manual_review',
    preparing: value?.status === 'preparing' || value?.status === 'queued',
    timeline: changed && effectiveDate
      ? `${currentLabel} until ${effectiveDate} → ${targetLabel} from ${effectiveDate}`
      : '',
  };
}

/**
 * No-change policy notices can outlive the snapshot used to create them.
 * Keep their copy aligned with the member's latest known billing cadence and
 * flag disagreements so callers do not show an amount for the wrong period.
 */
export function reconcileNoChangeCadencePresentation(transition = {}, currentCadence = null) {
  const currentLabel = cadenceFrequencyLabel(currentCadence, { capitalized: true });
  const hasCadenceConflict = Boolean(
    !transition.changed
    && currentLabel
    && transition.currentLabel
    && currentLabel !== transition.currentLabel
  );

  if (!hasCadenceConflict) {
    return { ...transition, hasCadenceConflict: false };
  }

  return {
    ...transition,
    currentCadence,
    currentLabel,
    hasCadenceConflict: true,
  };
}
